export default {
  token_time: 1800000,
  curTime: 300000
};
